import { render, staticRenderFns } from "./KeywordSelector.vue?vue&type=template&id=11031dea&scoped=true"
import script from "./KeywordSelector.vue?vue&type=script&lang=js"
export * from "./KeywordSelector.vue?vue&type=script&lang=js"
import style0 from "./KeywordSelector.vue?vue&type=style&index=0&id=11031dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11031dea",
  null
  
)

export default component.exports